export default __webpack_public_path__ + "static/media/undraw_web_developer.32cb989c.svg";